<template>
  <div>
    <b-alert
      show
      variant="danger"
      v-if="addRExito"
      style="width: 40%; margin: 0 auto"
      ><a href="#" class="alert-link">
        Se creo el convenio con exito !!</a
      ></b-alert
    >

    <va-notification color="danger" v-if="refNoUpdate" class="refNoData"
      >La actualizacion del programa presento un fallo.</va-notification
    >
    <va-notification color="danger" v-if="refWSUpdate" class="refNoData"
      >El servicio que ejecuta la actualización no se encuentra
      activo.</va-notification
    >

    <b-alert show variant="dark" v-if="refWSUpdate"
      ><a href="#" class="alert-link"
        >El servicio que ejecuta la actualización no se encuentra
      </a></b-alert
    >

    <ValidationObserver ref="obsFieldsSearch">
      <FormSearchProgram
        :FieldsForm="formSearch"
        :ModelForm="formSchModel"
        :method="executeProcess"
      />
    </ValidationObserver>
    <va-notification color="danger" id="refNoData" class="refNoData noShow"
      >No se encontró información del programa solicitado.</va-notification
    >
    <b-card-group
      deck
      style="width: 95%; height: 60%; margin: 0 auto; margin-top: 0%"
    >
      <b-card title=" " header-tag="header" footer-tag="footer">
        <div></div>
        <template #header>
          <h6 class="mb-0" style="margin: 0 auto">Convenio Periodo - Programas</h6>
        </template>

          <b-form inline>

            <multiselect
              v-model="value2"
              :options="options2"
              :custom-label="nameWithLang"
              placeholder="Selecciona programa"
              @input="showmodalistProgram"
              label="value"
              track-by="id"
              style="width: 65%; height: 40%; margin: 0 auto; margin-top: 0%"
              required
            ></multiselect>

      <multiselect
              v-model="value"
              :options="options"
              :custom-label="nameWithLang"
              placeholder="Selecciona periodo"
              @input="showmodalitiPeriod"
              label="value"
              track-by="id"
              required
              style="width: 30%; height: 40%; margin: 0 auto; margin-top: 0%"
            ></multiselect>

        <multiselect
          v-model="value8"
          :options="options6"
          :custom-label="nameWithLang"
          @input="aa"
          placeholder="Tipo de Ingreso"
          label="value"
          track-by="id"
          style="width: 20%; height: 40%; margin: 0 auto; margin-top: 2%"
          required></multiselect>

         <multiselect
        v-model="value6"
        :options="options4"
        :custom-label="nameWithLang"
         @input="aa"
        placeholder="Selecciona Jornada"
        label="value"
        track-by="id"
        style="width: 20%; height: 40%; margin: 0 auto; margin-top: 2%"
        required
      ></multiselect>

        <multiselect
        v-model="value5"
        :options="options3"
        :custom-label="nameWithLang"
        placeholder="Selecciona Modalidad"
        label="value"
        track-by="id"
        required
        style="width: 20%; height: 40%; margin: 0 auto; margin-top: 2%"
      ></multiselect>

      <multiselect
        v-model="value9"
        :options="options7"
        :custom-label="nameWithLang"
        placeholder="Selecciona Plan"
        label="value"
        track-by="id"
        style="width: 30%; height: 40%; margin: 0 auto; margin-top: 2%"
        required
      ></multiselect>

        <multiselect
        v-model="value7"
        :options="options5"
        :custom-label="nameWithLang"
        placeholder="Selecciona Estado"
        label="value"
        track-by="id"
        style="width: 30%; height: 40%; margin: 0 auto; margin-top: 2%"
        required
      ></multiselect>
        </b-form>

        <b-row>
          <b-col lg="6" class="pb-2" style="padding-top: 10px;">
            <b-button
              href="#"
              variant=""
              v-on:click="AddProgram"
              style="margin: 1% auto"
              >Guardar Convenio</b-button
            ></b-col
          >
        </b-row>
      </b-card>
    </b-card-group>
    <va-notification color="danger" v-if="Operatornull" class="refNoData"
      >por favor ingrese un operador y/o programa para
      continuar</va-notification
    >

    <div style="margin: 4% auto"></div>
    <div>
      <b-table
        striped
        hover
        :items="items"
        :fields="fields"
        :select-mode="selectMode"
        responsive="sm"
        ref="selectableTable"
        selectable
        @row-selected="NewEditModaliti"
        v-b-modal.modal-1
      >
      </b-table>
    </div>

    <b-modal id="modal-1" ref="my-modal" hide-footer>
      <template #modal-title> Editar convenios <code>IBERO</code> </template>

      <label class="typo__label"  >Periodo</label>
      <multiselect
        v-model="value4"
        :options="options"
        :custom-label="nameWithLang"
        placeholder="Selecciona periodo"
        label="value"
        track-by="id"
        required
        style="width: 60%; height: 40%; margin: 0 auto; margin-top: 0%"
      ></multiselect>

       <label class="typo__label"  >Programa</label>
      <div style="font-size: 4rem"></div>
      <multiselect
        v-model="value3"
        :options="options2"
        :custom-label="nameWithLang"
        placeholder="Selecciona operador"
        label="value"
        track-by="id"
        style="width: 60%; height: 40%; margin: 0 auto; margin-top: 6%"
        required
      ></multiselect>

        <label class="typo__label"  >Jornada</label>
        <multiselect
        v-model="value6"
        :options="options3"
        :custom-label="nameWithLang"
        placeholder="Selecciona"
        label="value"
        track-by="id"
        required
        style="width: 60%; height: 40%; margin: 0 auto; margin-top: 6%"
      ></multiselect>

       <label class="typo__label"  >Modalidad</label>
      <div style="font-size: 4rem"></div>
      <multiselect
        v-model="value5"
        :options="options4"
        :custom-label="nameWithLang"
        placeholder="Selecciona"
        label="value"
        track-by="id"
        style="width: 60%; height: 40%; margin: 0 auto; margin-top: 6%"
        required
      ></multiselect>

      <label class="typo__label">Tipo de Ingreso</label>
      <multiselect
          v-model="value8"
          :options="options6"
          :custom-label="nameWithLang"
          @input="aa"
          placeholder="Tipo de Ingreso"
          label="value"
          track-by="id"
          style="width: 60%; height: 40%; margin: 0 auto; margin-top: 6%"
          required></multiselect>

       <label class="typo__label">Estado</label>
      <multiselect
        v-model="value7"
        :options="options5"
        :custom-label="nameWithLang"
        placeholder="Selecciona"
        label="value"
        track-by="id"
        style="width: 60%; height: 40%; margin: 0 auto; margin-top: 6%"
        required
      ></multiselect>

      <label class="typo__label">Plan</label>
      <multiselect
        v-model="value9"
        :options="options7"
        :custom-label="nameWithLang"
        placeholder="Selecciona"
        label="value"
        track-by="id"
        style="width: 60%; height: 40%; margin: 0 auto; margin-top: 6%"
        required
      ></multiselect>

      <b-col lg="6" class="pb-2"    style="width: 60%; height: 40%; margin: 0 auto; margin-top: 6%">
        <b-button
          href="#"
          variant="info"
          v-on:click="updatemodaList"
          style="margin: 1% auto"
          >Editar Convenio</b-button
        ></b-col
      >

    </b-modal>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-duplicates
import FormSearchProgram from '@/components/forms/Forms.vue'
// eslint-disable-next-line import/no-duplicates
import FormupdatePeriods from '@/components/forms/Forms.vue'
import IberoHelpers from '@/store/helpers.js'
import DataTablePrograms from '@/components/data-tables/DataPeriod.vue'
import Multiselect from 'vue-multiselect'

export default {
  name: 'DataUpdate',
  components: {
    DataTablePrograms,
    FormSearchProgram,
    FormupdatePeriods,
    Multiselect,
  },
  data () {
    return {
      // Solo data multiselect
      selected: null,
      idProgra: [],
      value: [],
      value2: [],
      value3: [],
      value4: [],
      value5: [],
      value6: [],
      value7: [],
      value8: [],
      value9: [],

      addRExito: false,
      UpdRExito: false,
      refNoUpdate: false,
      refWSUpdate: false,
      Operatornull: false,
      okDelete: false,
      DeleteProg: true,
      programoperator: '',
      seccionvalid: '',
      ModalitPeriod: [],
      IDMODALITYprog: '',

      PeriodList: IberoHelpers.getPeriodProgList(this.$store),
      ProgramList: IberoHelpers.getPrograms2(this.$store),
      //PlanList: IberoHelpers.getPlan(this.$store),

      options: this.$store.state.PermanenceList,
      options2: this.$store.state.ProgramList,
      options7: this.$store.state.PlanList,

      formSchModel: { textvalue: '' },
      OperatorSearch: { Id_Operator: '' },
      IDPROGRAM: [],
      PROGRAM: [],
      CODPROGRAM: [],
      Id_OperatorProgram: [],

      // se crea la tabla dinamica con los programas

      fields: [
        {
          key: 'program',
          label: 'PROGRAMA',
          sortable: false,
        },
        {
          key: 'peridos',
          label: 'PERIODO',
          sortable: true,
        },
        {
          key: 'TypeIncome',
          label: 'TIPO DE INGRESO',
          sortable: false,
        },
        {
          key: 'IDWORKDAY',
          label: 'JORNADA',
          sortable: false,
        },
        {
          key: 'IDMODALITY',
          label: 'MODALIDAD',
          sortable: true,
        },
        {
          key: 'IDPLAN',
          label: 'PLAN',
          sortable: true,
        },
        {
          key: 'Sta_Active',
          label: 'ESTADO',
          sortable: true,
        },
        {
          key: 'DeleteRow',
          label: '',
          sortable: true,
          variant: 'primary',
        },
      ],

      options3: [
        { id: '1', value: 'Presencial' },
        { id: '2', value: 'Distancia' },
        { id: '3', value: 'Virtual' },
      ],
      options4: [
        { id: '1', value: 'Diurna' },
        { id: '2', value: 'Nocturna' },
        { id: '3', value: 'Distancia' },
        { id: '4', value: 'Virtual' },
        { id: '5', value: 'Tarde' },

      ],
      options5: [
        { id: '1', value: 'Activo' },
        { id: '0', value: 'InActivo' },
      ],
      options6: [
        { id: 'Primer Ingreso', value: 'Primer Ingreso' },
        { id: 'Homologante', value: 'Homologante' },
      ],

      items: [],
      DLPrograms: [],
      renderComponent1: false,
    }
  },
  methods: {

    NewEditModaliti (items) {
      debugger
      this.IberoProgram = items[0].program
      this.IberoPeriod = items[0].peridos
      this.IberoJornada = items[0].IDMODALITY
      this.IberoModality = items[0].IDWORKDAY
      this.IberoState = items[0].Sta_Active
      this.IDMODALITYprog = items[0].Id_Program_Modalities
      this.value4 = { id: items[0].Id_Period, value: items[0].peridos }
      this.value3 = { id: items[0].Id_Program, value: items[0].program }
      this.value5 = { id: items[0].Id_Modalities, value: items[0].IDMODALITY }
      this.value6 = { id: items[0].Id_Workday, value: items[0].IDWORKDAY }
      this.value7 = { id: items[0].Id_Program, value: items[0].Sta_Active }
      this.value8 = { id: items[0].TypeIncome, value: items[0].TypeIncome }
      // Plan
      debugger
      this.value9 = { id: items[0].Id_Plan, value: items[0].IDPLAN }

      if (items[0].Sta_Active === true) { this.value7 = { id: 1, value: 'Activo' } } else { this.value7 = { id: 0, value: 'InActivo' } };
    },

    updatemodaList (items) {
      debugger
      this.formSchModel.textvalue =
        '{"REFERENCE":' +
        3 +
        ',"PERIOD":' +
        this.value4.id.toString() +
        ',"TYPEINCOME": "' +
        this.value8.id.toString() +
        '" ,"IDPROGRAMODALITIES":' +
        this.IDMODALITYprog +
        ',"IDMODALITY":' +
        this.value5.id +
        ',"IDWORKDAY":' +
        this.value6.id +
        ',"STACTIVE":' +
        this.value7.id +
        ',"IDPROGRAM":' +
        this.value3.id +
        ',"IDPLAN":' +
        this.value9.id +
        '}'
      debugger
      var totalinf = IberoHelpers.addModalitiesProgram(
        this.$store,
        this.formSchModel
      )
      debugger
      totalinf.then((Response) => {
        this.renderComponent1 = false
        if (Response === false) {
          this.refWSUpdate = true
        } else if (!(Response.status === 200)) {
          this.refNoUpdate = true
        } else {
          this.addRExito = true
          this.value = ''
          this.value2 = ''
          this.value6 = ''
          this.value7 = ''
          this.value5 = ''
          this.items = ''
          this.value8 = ''
          this.value9 = ''
          this.$refs['my-modal'].hide()
        }
        this.$modal.hide('ProgramModal')
      })
    },

    AddProgram: function () {
      debugger

      try {
        this.formSchModel.textvalue =
        '{"REFERENCE":' +
        2 +
        ',"PERIOD":' +
        this.value.id.toString() +
        ',"TYPEINCOME": "' +
        this.value8.id.toString() +
        '","IDPROGRAMODALITIES":' +
        0 +
        ',"IDMODALITY":' +
        this.value5.id +
        ',"IDWORKDAY":' +
        this.value6.id +
        ',"STACTIVE":' +
        this.value7.id +
        ',"IDPROGRAM":' +
        this.value2.id +
        ',"IDPLAN":' +
        this.value9.id +
        '}'
      } catch (e) {
        alert('Seleccione todos los parámetros para guardar un convenio !!!')
        handleError(e, vm, info)
      }

      debugger
      var totalinf = IberoHelpers.addModalitiesProgram(
        this.$store,
        this.formSchModel
      )
      debugger
      totalinf.then((Response) => {
        debugger
        this.renderComponent1 = false
        if (Response === false) {
          this.refWSUpdate = true
        } else if (!(Response.status === 200)) {
          this.refNoUpdate = true
        } else {
          this.addRExito = true
          this.value = ''
          this.value2 = ''
          this.value6 = ''
          this.value7 = ''
          this.value5 = ''
          this.value8 = ''
          this.value9 = ''
        }
        this.$modal.hide('ProgramModal')
      })
    },

    showmodalitiPeriod () {
      debugger
      this.items = ''
      this.IberoProgram = 'items[0].program'
      if (this.value2.id == null) {
        var textvalue =
          '{"REFERENCE":' +
          '1' +
          ',"PERIOD":' +
          this.value.id.toString() +
          ',"TYPEINCOME":"' +
          '' +
          '","IDPROGRAMODALITIES":' +
          '0' +
          ',"IDMODALITY":' +
          '0' +
          ',"IDWORKDAY":' +
          '0' +
          ',"STACTIVE":' +
          '0' +
          ',"IDPROGRAM":' +
          '0' +
          '}'
      } else {
        textvalue =
          '{"REFERENCE":' +
          '1' +
          ',"PERIOD":' +
          this.value.id.toString() +
          ',"TYPEINCOME":"' +
          '' +
          '","IDPROGRAMODALITIES":' +
          '0' +
          ',"IDMODALITY":' +
          '0' +
          ',"IDWORKDAY":' +
          '0' +
          ',"STACTIVE":' +
          '0' +
          ',"IDPROGRAM":' +
          this.value2.id.toString() +
          '}'

        var totalinf = IberoHelpers.getModalitPeriodList(
          this.$store,
          textvalue
        )
        totalinf.then((Response) => {
          debugger
          this.renderComponent1 = false
          if (Response === false) {
            // this.refWSUpdate = true
          } else if (!(Response.status === 200)) {
            // this.refNoUpdate = true
          } else {
            debugger

            this.items = Response.data
            for (let index = 0; index < this.items.length; index++) {
              var stringboton = 'EDITAR CONVENIO'
              this.items[index].DeleteRow = stringboton
            }
          }
        })
      }

      debugger
      totalinf = IberoHelpers.getModalitPeriodList(this.$store, textvalue)
      totalinf.then((Response) => {
        this.renderComponent1 = false
        if (Response === false) {
          // this.refWSUpdate = true
        } else if (!(Response.status === 200)) {
          // this.refNoUpdate = true
        } else {
          this.items = Response.data
          for (let index = 0; index < this.items.length; index++) {
            var stringboton = 'EDITAR CONVENIO'
            this.items[index].DeleteRow = stringboton
          }
        }
      })
    },

    showmodalistProgram: function () {
      debugger
      this.items = ''
      if (this.value.id == null) {
        var textvalue =
          '{"REFERENCE":' +
          '1' +
          ',"PERIOD":' +
          '0' +
          ',"TYPEINCOME":"' +
          '' +
          '","IDPROGRAMODALITIES":' +
          '0' +
          ',"IDMODALITY":' +
          '0' +
          ',"IDWORKDAY":' +
          '0' +
          ',"STACTIVE":' +
          '0' +
          ',"IDPROGRAM":' +
          this.value2.id.toString() +
          '}'
      } else {
        textvalue =
          '{"REFERENCE":' +
          '1' +
          ',"PERIOD":' +
          this.value.id.toString() +
          ',"TYPEINCOME":"' +
          this.value8.id.toString() +
          '","IDPROGRAMODALITIES":' +
          '0' +
          ',"IDMODALITY":' +
          '0' +
          ',"IDWORKDAY":' +
          '0' +
          ',"STACTIVE":' +
          '0' +
          ',"IDPROGRAM":' +
          this.value2.id.toString() +
          '}'

        var totalinf = IberoHelpers.getModalitPeriodList(
          this.$store,
          textvalue
        )
        totalinf.then((Response) => {  
          this.renderComponent1 = false
          if (Response === false) {
            // this.refWSUpdate = true
          } else if (!(Response.status === 200)) {
            // this.refNoUpdate = true
          } else {
            debugger
            this.items = Response.data
            for (let index = 0; index < this.items.length; index++) {
              var stringboton = 'EDITAR CONVENIO'
              this.items[index].DeleteRow = stringboton
            }
          }
        })
      }

      debugger
      this.$store.state.PlanList.length = 0;
      PlanList: IberoHelpers.getPlanIdProgram(this.$store,this.value2.id.toString())
      debugger
      totalinf = IberoHelpers.getModalitPeriodList(this.$store, textvalue)
      totalinf.then((Response) => {
        this.renderComponent1 = false
        if (Response === false) {
          // this.refWSUpdate = true
        } else if (!(Response.status === 200)) {
          // this.refNoUpdate = true
        } else {
          debugger
          // Lista de programas consultados
          this.items = Response.data

          for (let index = 0; index < this.items.length; index++) {
            var stringboton = 'EDITAR CONVENIO'
            this.items[index].DeleteRow = stringboton
          }
        }
      })
    },

    onRowSelected (items) {
      debugger
      if (this.seccionvalid === '1') {
        this.seccionvalid = ''
        return 'error'
      }
      this.$refs['my-modal'].show()

      this.ModalitPeriod = items
    },
    processData: function (dataInf, refdata) {
      this.limpiaref()
      this.isNew = false
      this.formUpdModel.desPeriod = dataInf.desPeriod
      if (dataInf.staActive === true) {
        this.formUpdModel.staActive = 1
      } else {
        this.formUpdModel.staActive = 0
      }
      this.formUpdModel.datStartDate = dataInf.datStartDate
      this.formUpdModel.datEndDate = dataInf.datEndDate
      this.formUpdModel.dat_StrartInscription = dataInf.dat_StrartInscription
      this.formUpdModel.dat_EndInscription = dataInf.dat_EndInscription
      IberoHelpers.forceRerender2(this)
      this.$modal.show('ProgramModal')
    },
  },
}
</script>